<template>
  <div class="div_btn">
    <div v-if="shouldShowSeguirLeiloeiro" style="margin-bottom: -15px;">
      <div :class="'toggle-seguir '+(seguir ? 'toggle-on' : '')" id='switch_seguir' @click="$emit('seguirLeiloeiro')">
        <div class='toggle-text-off'>Seguir Leiloeiro</div>
        <div class='glow-comp'></div>
        <div class='toggle-button'></div>
        <div class='toggle-text-on'>Seguindo Leiloeiro</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Seguirleiloeiro',
  props: [
    'lote_id_pregao',
    'leilao',
    'seguir',
    'tela'
  ],
  computed: {
    shouldShowSeguirLeiloeiro() {
      return this.leilao && (this.tela === 'saladisputa' || this.tela === 'loteaberto') &&
        this.create_seguir_leiloeiro() &&
        this.leilao.statusleilao_id !== 17;
    }
  },
  methods: {
    create_seguir_leiloeiro() {
      const fechamentoAutomaticoAtivo = this.leilao.bn_fechamentoautomatico === false;
      const fechamentoSimultaneoZero = this.leilao.statusfechamentosimultaneo_id !== null;
      const loteIdPregaoPreenchido = (this.leilao.statuslotemoderador_id !== null) ? this.leilao.statuslotemoderador_id : this.leilao.lote_id;

      if (this.leilao && this.leilao.bn_fechamentoautomatico === false) {
        return true;
      } else {
        return (fechamentoAutomaticoAtivo && fechamentoSimultaneoZero) ||
          (!fechamentoAutomaticoAtivo && loteIdPregaoPreenchido);
      }
    }
  }
}
</script>
<style>
/* BOTÃO TOGGLE SEGUIR */
.div_btn {
  display: flex;
  justify-content: space-between;
}

.abre_telao.toggle-seguir {
  margin-left: 15px;
  display: flex;
  padding: 5px;
  font-weight: bold;
  position: relative;
}

#switch_seguir {
  width: 153px;
  height: 40px;
  position: relative;
}

.toggle-seguir {
  position: absolute;
  border: 2px solid #0a1a3d;
  border-radius: 20px;
  -webkit-transition: border-color .6s ease-out;
  transition: border-color .6s ease-out;
  box-sizing: border-box;
}

.toggle-seguir.toggle-on {
  border-color: rgba(137, 194, 217, .4);
  -webkit-transition: all .5s .15s ease-out;
  transition: all .5s .15s ease-out;
}

.toggle-button {
  position: absolute;
  top: 4px;
  width: 28px;
  bottom: 4px;
  right: 117px;
  background-color: #1c2d47;
  border-radius: 19px;
  cursor: pointer;
  -webkit-transition: all .3s .1s, width .1s, top .1s, bottom .1s;
  transition: all .3s .1s, width .1s, top .1s, bottom .1s;
}

.toggle-on .toggle-button {
  top: 3px;
  width: 143px;
  bottom: 3px;
  right: 3px;
  border-radius: 23px;
  background-color: #89da8b;
  -webkit-box-shadow: 0 0 16px #89da8b;
  box-shadow: 0 0 16px #89da8b;
  -webkit-transition: all .2s .1s, right .1s;
  transition: all .2s .1s, right .1s;
}

.toggle-text-on {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: normal;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  color: rgba(0, 0, 0, 0);
}

.toggle-on .toggle-text-on {
  color: #3b6a7d;
  font-size: 14px;
  -webkit-transition: color .3s .15s;
  transition: color .3s .15s;
}

.toggle-text-off {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 6px;
  line-height: 36px;
  text-align: center;
  font-family: 'Quicksand', sans-serif;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  user-select: none;
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
  cursor: pointer;
  color: #444249;
}

.toggle-on .toggle-text-off {
  color: rgba(0, 0, 0, 0);
}

.glow-comp {
  position: absolute;
  opacity: 0;
  top: 10px;
  bottom: 10px;
  left: 10px;
  right: 10px;
  border-radius: 6px;
  background-color: rgba(75, 122, 141, .1);
  box-shadow: 0 0 12px rgba(75, 122, 141, .2);
  -webkit-transition: opacity 4.5s 1s;
  transition: opacity 4.5s 1s;
}

.toggle-on .glow-comp {
  opacity: 1;
  -webkit-transition: opacity 1s;
  transition: opacity 1s;
}

/* //BOTÃO TOGGLE SEGUIR */
</style>



// WEBPACK FOOTER //
// src/components/shared/SeguirLeiloeiro.vue